// extracted by mini-css-extract-plugin
export default {"splitter":"SplitterHorizontal_splitter__IwM6p"};